import { render, staticRenderFns } from "./RevisionChicks.vue?vue&type=template&id=2aa7547a"
import script from "./RevisionChicks.vue?vue&type=script&lang=js"
export * from "./RevisionChicks.vue?vue&type=script&lang=js"
import style0 from "./RevisionChicks.vue?vue&type=style&index=0&id=2aa7547a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports